import { useI18n } from "@/lib/i18n";
import { useSite } from "@/lib/site";
import { Shield, Clock, Award, Users } from "lucide-react";

const FEATURES = [
  { icon: Shield, key: "shield", en: "Insurance Accepted", es: "Aceptamos Seguros" },
  { icon: Clock, key: "clock", en: "Fast Turnaround", es: "Entregas Rápidas" },
  { icon: Award, key: "award", en: "Certified Technicians", es: "Técnicos Certificados" },
  { icon: Users, key: "users", en: "Family Owned", es: "Negocio Familiar" },
];

export default function About() {
  const { t, lang, pick } = useI18n();
  const { site } = useSite();
  if (!site) return null;

  return (
    <section id="about" data-testid="about" className="relative carbon-surface py-20 sm:py-28 border-b border-zinc-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <div className="tech-label mb-4 !text-brand-red">{t("about.label")}</div>
          <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight chrome-text">
            {pick(site.about_title)}
          </h2>
        </div>

        <div className="lg:col-span-7 flex flex-col gap-8">
          <p className="text-base sm:text-lg text-zinc-400 leading-relaxed">
            {pick(site.about_body)}
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-4 grid-border border-t border-l border-zinc-800">
            {FEATURES.map((f) => {
              const Icon = f.icon;
              return (
                <div key={f.key} className="p-5 sm:p-6 bg-zinc-950">
                  <Icon size={22} className="text-brand-red mb-3" strokeWidth={2.2} />
                  <div className="font-display font-extrabold text-base sm:text-lg text-white leading-tight">
                    {lang === "es" ? f.es : f.en}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
